import { render, staticRenderFns } from "./BatchGoods.vue?vue&type=template&id=f75d00b0&scoped=true&"
import script from "./BatchGoods.vue?vue&type=script&lang=js&"
export * from "./BatchGoods.vue?vue&type=script&lang=js&"
import style0 from "./BatchGoods.vue?vue&type=style&index=0&id=f75d00b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f75d00b0",
  null
  
)

export default component.exports